import { combineReducers } from 'redux';

import app from './app';
import winners from './winners.js';
import winnerHistory from './winner-history.js';

export default combineReducers({
  app,
  winners,
  winnerHistory,
});

export { app, winners, winnerHistory };
